import { fromJS } from 'immutable'
import { createReducer } from 'redux-immutablejs'

import { BenefitGroup, COMMON_MIXPANEL_PAGE, serializeBenefitCategories } from '@lyrahealth-inc/shared-app-logic'
import { ENTRY_CARD_DISMISSED_LOCAL_STORAGE_KEY } from '@lyrahealth-inc/ui-core-crossplatform'

import {
  CLEAR_INTEGRATED_BENEFITS_ENTRY_POINT,
  GET_ALL_BENEFITS_FOR_USER_fulfilled,
  GET_RECOMMENDED_BENEFITS_FOR_USER_fulfilled,
  SET_INTEGRATED_BENEFITS_ENTRY_POINT,
} from './benefitsActions'

const initialState = fromJS({})
export default createReducer(initialState, {
  [GET_RECOMMENDED_BENEFITS_FOR_USER_fulfilled]: ($$state: $TSFixMe, action: $TSFixMe) => {
    const benefitGroups: BenefitGroup[] = action?.payload ?? []
    const newRecommendations = serializeBenefitCategories({ benefitGroups })
    const oldRecommendations = localStorage.getItem(ENTRY_CARD_DISMISSED_LOCAL_STORAGE_KEY)
    if (newRecommendations !== oldRecommendations) {
      localStorage.removeItem(ENTRY_CARD_DISMISSED_LOCAL_STORAGE_KEY)
    }

    return $$state.set('recommendedBenefitGroupsForUser', action?.payload)
  },
  [GET_ALL_BENEFITS_FOR_USER_fulfilled]: ($$state: $TSFixMe, action: $TSFixMe) => {
    return $$state.set('allBenefitGroupsForUser', action?.payload)
  },
  [SET_INTEGRATED_BENEFITS_ENTRY_POINT]: ($$state: $TSFixMe, action: { data: COMMON_MIXPANEL_PAGE }) => {
    return $$state.set('integratedBenefitsEntryPoint', action?.data)
  },
  [CLEAR_INTEGRATED_BENEFITS_ENTRY_POINT]: ($$state: $TSFixMe) => {
    return $$state.set('integratedBenefitsEntryPoint', undefined)
  },
})
